import { render, staticRenderFns } from "./visualizador.vue?vue&type=template&id=779c0068&scoped=true"
import script from "./visualizador.vue?vue&type=script&lang=js"
export * from "./visualizador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779c0068",
  null
  
)

export default component.exports